var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.41669V4.25002M5.66663 1.41669V4.25002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20833 2.83331H7.79167C5.12037 2.83331 3.78473 2.83331 2.95486 3.66317C2.125 4.49304 2.125 5.82868 2.125 8.49998V9.91665C2.125 12.5879 2.125 13.9236 2.95486 14.7534C3.78473 15.5833 5.12037 15.5833 7.79167 15.5833H9.20833C11.8796 15.5833 13.2153 15.5833 14.0451 14.7534C14.875 13.9236 14.875 12.5879 14.875 9.91665V8.49998C14.875 5.82868 14.875 4.49304 14.0451 3.66317C13.2153 2.83331 11.8796 2.83331 9.20833 2.83331Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 7.08331H14.875",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49677 9.91669H8.50315M8.49677 12.75H8.50315M11.3269 9.91669H11.3333M5.66663 9.91669H5.67298M5.66663 12.75H5.67298",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAi);
export default __webpack_public_path__ + "static/media/calendar-ai.ce6c5a4560b171c6264fb95eb0769728.svg";
export { ForwardRef as ReactComponent };